import React, { useState } from "react";

/* =========================================================
   FULL PAGE BILLDESK REDIRECT
   ========================================================= */
const redirectToBillDesk = (redirect) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = redirect.url; // BillDesk URL

  const addHidden = (name, value) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  addHidden("bdorderid", redirect.params.bdorderid);
  addHidden("merchantid", redirect.params.mercid);
  addHidden("rdata", redirect.params.rdata);

  document.body.appendChild(form);
  form.submit();
};

/* =========================================================
   SIMPLIFIED PAYMENT PAGE
   ========================================================= */
const Payment1 = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const FIXED_AMOUNT = 118; // Fixed registration amount // AMOUNT CHANGE

  const handlePayment = async () => {
    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("access_token");
      if (!token) {
        throw new Error("Please login first");
      }

      // Create payment order with fixed amount
      const paymentData = {
        amount: FIXED_AMOUNT,
        payment_type: "REG"
      };

      const res = await fetch("/api/payment/create-order", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}` // Send JWT token
        },
        body: JSON.stringify(paymentData),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || errorData.detail || "Payment initialization failed");
      }

      const data = await res.json();
      
      // Redirect to BillDesk
      redirectToBillDesk(data.billdesk_response.redirect);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Registration Payment</h2>
        
        <div style={styles.amountSection}>
          <div style={styles.amountLabel}>Amount to Pay:</div>
          <div style={styles.amountValue}>₹{FIXED_AMOUNT}</div>
          <div style={styles.amountNote}>Registration Fee</div>
        </div>

       {/*<button 
          onClick={handlePayment}
          disabled={loading}
          style={loading ? styles.buttonDisabled : styles.button}
        >
          {loading ? "Processing..." : "Proceed to Payment"}
        </button>*/}
        
        <h1>Payment window is over</h1>

        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.note}>
          You will be redirected to BillDesk payment gateway
        </div>
      </div>
    </div>
  );
};

/* =========================================================
   STYLES
   ========================================================= */
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    padding: "20px"
  },
  card: {
    background: "white",
    borderRadius: "10px",
    padding: "40px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center"
  },
  title: {
    color: "#333",
    marginBottom: "30px",
    fontSize: "24px"
  },
  amountSection: {
    marginBottom: "30px",
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px"
  },
  amountLabel: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "5px"
  },
  amountValue: {
    fontSize: "36px",
    fontWeight: "bold",
    color: "#28a745",
    marginBottom: "5px"
  },
  amountNote: {
    fontSize: "12px",
    color: "#999"
  },
  button: {
    width: "100%",
    padding: "15px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "background-color 0.3s"
  },
  buttonDisabled: {
    width: "100%",
    padding: "15px",
    backgroundColor: "#6c757d",
    color: "white",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "not-allowed"
  },
  buttonHover: {
    backgroundColor: "#0056b3"
  },
  error: {
    marginTop: "15px",
    padding: "10px",
    backgroundColor: "#f8d7da",
    color: "#721c24",
    borderRadius: "5px",
    fontSize: "14px"
  },
  note: {
    marginTop: "20px",
    fontSize: "12px",
    color: "#666",
    fontStyle: "italic"
  }
};

// Add hover effect
const addHoverEffect = () => {
  const button = document.querySelector('button[style*="background-color: #007bff"]');
  if (button) {
    button.addEventListener('mouseover', () => {
      button.style.backgroundColor = "#0056b3";
    });
    button.addEventListener('mouseout', () => {
      button.style.backgroundColor = "#007bff";
    });
  }
};

// Initialize hover effect after component mounts
setTimeout(addHoverEffect, 100);

export default Payment1;
